export class AppError {
  inner: { path?: string; message: string }[];

  constructor(path: string, message: string) {
    this.inner = [];
    this.inner.push({ path, message });
  }
}
